import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { FilterField } from '../../dialogs/grid-filters/grid-filters.component';

@Component({
  selector: 'app-filters-chimp',
  templateUrl: './filters-chimp.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./filters-chimp.component.scss'],
})
export class FiltersChimpComponent {
  @Input() filters: object;
  @Input() fields: FilterField[];
  @Input() client_side_filters: object;

  @Output() removeFilter = new EventEmitter<string>();
  @Output() removeClientSideFilter = new EventEmitter<string>();

  hasFilterInFields(
    filter: string
  ): boolean {
    return this.fields.some(field => field.name === filter)
  }
  


  getField(key: string) {
    return this.fields.find((i) => i.name === key);
  }
}
